import React, { Fragment } from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { ChartOfAccount } from '../../types/coa.types';
interface AccountHierarchyProps {
  account: ChartOfAccount;
  parentAccounts?: ChartOfAccount[];
}
export function AccountHierarchy({
  account,
  parentAccounts = []
}: AccountHierarchyProps) {
  const hierarchy = [...parentAccounts, account];
  return <div className="bg-gray-50 p-4 rounded-lg border" data-id="element-67">
      <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-68">
        Account Hierarchy
      </h4>
      <div className="flex items-center gap-2 flex-wrap" data-id="element-69">
        {hierarchy.map((acc, index) => <Fragment key={acc.id} data-id="element-70">
            {index > 0 && <ChevronRightIcon className="w-4 h-4 text-gray-400" data-id="element-71" />}
            <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded border" data-id="element-72">
              <span className="font-mono text-xs text-gray-600" data-id="element-73">
                {acc.accountCode}
              </span>
              <span className="text-sm font-medium text-gray-900" data-id="element-74">
                {acc.accountName}
              </span>
            </div>
          </Fragment>)}
      </div>

      {account.children && account.children.length > 0 && <div className="mt-4" data-id="element-75">
          <h5 className="text-xs font-medium text-gray-600 mb-2" data-id="element-76">
            Child Accounts ({account.children.length})
          </h5>
          <div className="space-y-1" data-id="element-77">
            {account.children.map(child => <div key={child.id} className="flex items-center gap-2 text-sm" data-id="element-78">
                <span className="font-mono text-gray-600" data-id="element-79">
                  {child.accountCode}
                </span>
                <span className="text-gray-900" data-id="element-80">{child.accountName}</span>
              </div>)}
          </div>
        </div>}
    </div>;
}